"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductSalesChannelId = exports.getSalesChannelCustomFieldTitle = exports.getCategoryNameOfProduct = exports.showBulkPrices = exports.isSoftware = exports.updateUsage = exports.updateContactName = exports.updateContactId = exports.downloadLicenses = exports.isProductCategorySoftware = exports.isReseller = exports.showPrices = exports.getUniqueSortedPropertyOptions = exports.getQuantityOptions = exports.getMaxPurchase = exports.getMinPurchase = exports.availablePropertyGroups = exports.generateProductDescriptionTexts = void 0;
const file_saver_1 = require("file-saver");
const react_toastify_1 = require("react-toastify");
const ecommerce_1 = require("../../api/ecommerce");
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const array_1 = require("../../common/js/helper/array");
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const Categories_1 = __importDefault(require("../enums/Categories"));
const ProductSalesChannelId_1 = __importDefault(require("../enums/ProductSalesChannelId"));
const LicenseStore_1 = __importDefault(require("../stores/LicenseStore"));
const ShopwareCategories_1 = __importDefault(require("../stores/ShopwareCategories"));
const ShopwareContext_1 = __importDefault(require("../stores/ShopwareContext"));
const generateProductDescriptionTexts = (product, multiValueSeparator) => {
    if (!product) {
        return [];
    }
    if (!product.extensions?.massiveCategoryTree?.ids || product.extensions?.massiveCategoryTree?.ids.length <= 1) {
        return [];
    }
    const [, ...categories] = product.extensions?.massiveCategoryTree?.ids ?? [];
    if (!categories) {
        return [];
    }
    const reversedCategories = categories.reverse();
    const displayedPropertiesForCategories = reversedCategories
        .map((categoryId) => ShopwareCategories_1.default.getCategory(categoryId)?.extensions?.massiveCategory?.displayedProperties ?? null)
        .filter((value) => !!value);
    if (!displayedPropertiesForCategories || displayedPropertiesForCategories.length <= 0) {
        return [];
    }
    const displayedProperties = (0, array_1.first)(displayedPropertiesForCategories);
    return (displayedProperties
        ?.slice()
        ?.sort((a, b) => a.position - b.position)
        ?.map((displayedProperty) => {
        const properties = product.extensions?.massiveProperties?.filter((property) => property.group?.id === displayedProperty.propertyId) ?? [];
        const propertyGroup = (0, array_1.first)(properties)?.group;
        const propertyValues = properties
            .sort((a, b) => (a.translated?.position ?? 0) - (b.translated?.position ?? 0))
            .map((property) => property.translated?.name);
        // In case more than one property value is assigned to the product for a group.
        const propertyValueText = propertyValues.join(multiValueSeparator);
        if (!propertyValueText) {
            return '';
        }
        if (!propertyGroup?.translated?.name ||
            ecommerce_1.MassiveCategoryDisplayedPropertyDisplayTypeEnum.Value === displayedProperty.displayType) {
            return propertyValueText;
        }
        const delimiterString = displayedProperty.delimiterString ? displayedProperty.delimiterString : ': ';
        return `${propertyGroup.translated?.name}${delimiterString}${propertyValueText}`;
    })
        ?.filter((value) => !!value) ?? []);
};
exports.generateProductDescriptionTexts = generateProductDescriptionTexts;
const availablePropertyGroups = (products, propertyGroupIds) => {
    return products
        .flatMap((p) => p.extensions?.massiveProperties)
        .flatMap((p) => p?.group)
        .filter((p) => !!p)
        .filter((p) => p.id && propertyGroupIds.includes(p.id));
};
exports.availablePropertyGroups = availablePropertyGroups;
const getMinPurchase = (product) => {
    return product.purchaseSteps ?? product.minPurchase ?? 1;
};
exports.getMinPurchase = getMinPurchase;
const getMaxPurchase = (product) => {
    if (null === product.calculatedMaxPurchase || undefined === product.calculatedMaxPurchase) {
        return 100;
    }
    if (product.calculatedMaxPurchase <= 0) {
        return 1;
    }
    return product.calculatedMaxPurchase;
};
exports.getMaxPurchase = getMaxPurchase;
const getQuantityOptions = (minQuantity, product) => {
    const maxPurchase = (0, exports.getMaxPurchase)(product);
    const purchaseSteps = Math.max(1, product.purchaseSteps ?? 0);
    if (purchaseSteps <= 1) {
        return {};
    }
    const options = {};
    for (let quantity = minQuantity; quantity <= maxPurchase; quantity = quantity + purchaseSteps) {
        options[String(quantity)] = String(quantity);
    }
    return options;
};
exports.getQuantityOptions = getQuantityOptions;
const getUniqueSortedPropertyOptions = (products, propertyGroupId) => {
    return products
        .flatMap((product) => product.extensions?.massiveProperties)
        .filter((property) => !!property)
        .filter((property) => property.groupId === propertyGroupId)
        .sort((a, b) => (a.translated?.position ?? 0) - (b.translated?.position ?? 0))
        .reduce((options, property) => property.id ? [...options, { value: property.id, label: property.translated?.name ?? '' }] : options, [])
        .filter((option, index, array) => {
        const otherIndex = array.findIndex((otherOption) => otherOption.value === option.value);
        return otherIndex === index;
    });
};
exports.getUniqueSortedPropertyOptions = getUniqueSortedPropertyOptions;
const showPrices = (product) => {
    if (!AuthorizationStore_1.default.hasScope(AuthorizationScopes_1.default.SHOP_READ)) {
        return false;
    }
    if (!(0, exports.isReseller)()) {
        return true;
    }
    if (!product) {
        return false;
    }
    return (0, exports.isProductCategorySoftware)(product);
};
exports.showPrices = showPrices;
const isReseller = () => {
    return ['98', '99'].includes(AuthorizationStore_1.default.channelId ?? '');
};
exports.isReseller = isReseller;
const isProductCategorySoftware = (product) => {
    return !!product.categories?.find((category) => category.extensions?.massiveCategory?.externalId === Categories_1.default.SOFTWARE);
};
exports.isProductCategorySoftware = isProductCategorySoftware;
const downloadLicenses = (licenseId) => {
    LicenseStore_1.default.downloadMassiveLicense(licenseId)
        .then((download) => {
        if (download.blob) {
            react_toastify_1.toast.success((0, translation_1.t)('myassets.download.success'));
            (0, file_saver_1.saveAs)(download.blob, download.fileName);
        }
    })
        .catch(() => {
        react_toastify_1.toast.error((0, translation_1.t)('myassets.download.fail'));
    });
};
exports.downloadLicenses = downloadLicenses;
const updateContactId = (licenseId, licenseContactId) => {
    const license = LicenseStore_1.default.licenses.get(licenseId);
    if (!!license) {
        license.licenseContactId = licenseContactId;
    }
};
exports.updateContactId = updateContactId;
const updateContactName = (licenseId, licenseContact) => {
    const license = LicenseStore_1.default.licenses.get(licenseId);
    if (!!license) {
        license.licenseContactName = `${licenseContact.firstName} ${licenseContact.lastName}`;
    }
};
exports.updateContactName = updateContactName;
const updateUsage = (licenseId, licenseUsage) => {
    const license = LicenseStore_1.default.licenses.get(licenseId);
    if (!!license) {
        license.usage = licenseUsage;
    }
};
exports.updateUsage = updateUsage;
const isSoftware = (additionalSeatsCount) => {
    return null !== additionalSeatsCount;
};
exports.isSoftware = isSoftware;
const showBulkPrices = (categoryIsSoftware, product) => {
    if (!(0, exports.showPrices)() || categoryIsSoftware) {
        return false;
    }
    const calculatedPrices = product?.calculatedPrices ?? [];
    if (calculatedPrices.length <= 1) {
        return false;
    }
    return true;
};
exports.showBulkPrices = showBulkPrices;
const getCategoryNameOfProduct = (product) => {
    const categories = product.extensions?.massiveCategoryTree?.ids;
    if (!categories?.length) {
        return undefined;
    }
    return ShopwareCategories_1.default.getCategory(categories.filter((categoryId) => categoryId !== Categories_1.default.PRODUCT_CATALOGUE)[0])?.translated?.name;
};
exports.getCategoryNameOfProduct = getCategoryNameOfProduct;
const getSalesChannelCustomFieldTitle = () => {
    return ('zkp_landing_page_priority_' +
        ShopwareContext_1.default.context?.salesChannel?.extensions?.massiveSalesChannel
            ?.salesChannelId);
};
exports.getSalesChannelCustomFieldTitle = getSalesChannelCustomFieldTitle;
const getProductSalesChannelId = () => {
    const mandateId = ('m' +
        ShopwareContext_1.default.context?.salesChannel?.extensions?.massiveSalesChannel
            ?.externalId);
    return ProductSalesChannelId_1.default[mandateId];
};
exports.getProductSalesChannelId = getProductSalesChannelId;
